import { Button } from 'components/v2/atoms/button';
import useGlobalStore from 'store/global';

export interface LoginSignupPRType {
  className?: string;
}

const LoginSignupPR = ({ className = '' }: LoginSignupPRType) => {
  const showLogin = useGlobalStore((state) => state.showLogin);
  return (
    <div
      className={`all-font-sans flex flex-col items-center justify-center rounded-xl border-2 border-solid border-pp-text-primary bg-white p-4 ${className}`}
    >
      {/* Welcome Text */}
      <div className="mb-4 text-center">
        <h1 className="mb-4 text-[18px] font-bold text-pp-text-primary">
          PostPrimeへようこそ
        </h1>
        <p className="whitespace-pre text-sm leading-relaxed text-pp-text-secondary">
          投資のプロやトレーダーと繋がり、{'\n'}
          最新の市場情報やトレードアイデアを共有しよう！
        </p>
      </div>

      {/* Action Buttons */}
      <div className="flex items-center justify-center space-x-3">
        {/* Login Button */}
        <Button
          variant="outlineDefault"
          size="lg"
          className="rounded-full px-4 py-3 text-sm font-light transition-colors hover:bg-pp-bg-tertiary"
          onClick={() => showLogin({ showingTitle: 'login' })}
        >
          ログイン
        </Button>

        {/* Sign Up Button */}
        <Button
          variant="primaryGreen"
          size="lg"
          className="rounded-full px-4 py-3 text-sm font-light"
          onClick={() => showLogin({ showingTitle: 'signup' })}
        >
          新規登録
        </Button>
      </div>
    </div>
  );
};

export default LoginSignupPR;
